/* -------------------------------------------------------------------------- */
/* FORMS MIXIN                                                                */
/* -------------------------------------------------------------------------- */
import {
    Component, Emit, Mixins, Watch,
} from 'vue-property-decorator';
import { digits } from '@groot-nodes/helpers/number';
import FormsProps from './props';
import Hybrid from '../hybrid';
import YFieldWrapper from '@groot-components/field-wrapper';

/**
 * Forms Mixin
 */
@Component({
    components: {
        YFieldWrapper,
    },
})
class FormsMixin extends Mixins(FormsProps, Hybrid) {
    model: any = this.init || this.getValue('default') || null;
    modelType: string = 'string';
    charCount: number = typeof this.model === 'string' ? this.model.length : 0;

    /**
     * Return the LabelFor
     * 
     * @returns {string}
     */
    get labelFor(): string {
        return this.getValue('id') || this.getValue('name');
    }

    /**
     * Return the Label
     * 
     * @returns {string}
     */
    get labelValue(): string {
        return this.getValue('label') || this.$t(`fields.${this.getValue('name')}`);
    }

    /**
     * Field Wrapper Props
     *
     * @returns {object}
     */
    get fieldWrapperProps(): object {
        return {
            ...this.$props,
            labelFor : this.labelFor,
            label    : this.labelValue,
            charCount: this.charCount,
        };
    }

    /**
     * Set Element Value to model
     *
     * @param {*} val
     */
    @Watch('elements.value', { immediate: true, deep: true })
    onElementValueChanged(val: any): any {
        if (val) {
            this.model = val;
        }
    }

    /**
     * Set Element Value to model
     *
     * @param {*} val
     */
    @Watch('value', { immediate: true, deep: true })
    onValueChanged(val: any): any {
        if (val) {
            this.model = val;
        }
    }

    /**
     * Set Element Value to model
     *
     * @param {*} val
     */
    @Watch('init', { immediate: true, deep: true })
    onInitChanged(val: any): any {
        if (val) {
            this.model = val;
        }
    }

    /**
     * Emit model when Changed
     * 
     * @returns {any}
     */
    @Watch('model', { immediate: true, deep: true })
    @Emit('input')
    onModelChanged(): any {
        if (typeof this.model === 'string') {
            this.charCount = this.model.length;
        }
        if (this.modelType === 'number') {
            return Number(digits(this.model, 'en'));
        }
        return this.model;
    }

    /**
     * Emit 'blur' event
     * 
     * @param {object} e
     */
    @Emit('blur')
    onBlur(e: object) {}

    /**
     * Emit 'focus' event
     * 
     * @param {object} e
     */
    @Emit('focus')
    onFocus(e: object) {}
}

export default FormsMixin;
